import 'aframe';
import { HOTSPOT_LABEL_THEME, HOTSPOT_THEME_CONFIGS } from '../../../constants';
import '../../AFrame/components/roundedRect';


const DEFAULT_TEXT_COLOR = HOTSPOT_THEME_CONFIGS[HOTSPOT_LABEL_THEME.DEFAULT].textColor;
const DEFAULT_BACKGROUND_COLOR = HOTSPOT_THEME_CONFIGS[HOTSPOT_LABEL_THEME.DEFAULT].backgroundColor;

// custom text-background component
AFRAME.registerComponent('text-background', {
  schema: {
    padding: {type: 'number', default: 0.1},
    color: {type: 'string', default: DEFAULT_BACKGROUND_COLOR},
    textColor: {type: 'string', default: DEFAULT_TEXT_COLOR},
    radius: { type: 'number', default: 0.1 },
    opacity: { type: 'number', default: 0.8 },
  },
  init: function () {
    // create the main background element
    const bgEl = document.createElement('a-entity');
    bgEl.setAttribute('position', '0 0 -0.01');
    bgEl.setAttribute('rounded-rect', `width: 1; height: 1; radius: ${this.data.radius}; color: ${this.data.color}; opacity: ${this.data.opacity}`);

    this.el.appendChild(bgEl);
    this.bgEl = bgEl;
    this.meshUpdated = false;

    this.el.addEventListener('object3dset', () => this.updateBg());
  },
  tick: function () {
    if (!this.meshUpdated) {
      this.updateBg();
    }
  },
  updateBg: function () {
    let mesh = this.el.getObject3D('text');
    if (!mesh?.geometry?.attributes?.position?.array) {
      return;
    }
    mesh.geometry.computeBoundingBox();
    const box = mesh.geometry.boundingBox;
    const meshWidth = box.max.x - box.min.x;
    const meshHeight = box.max.y - box.min.y;

    const textWidthAttr = this.el.getAttribute('text').width || 10;

    // different scaling factors for different text widths
    let scalingFactor;
    if (textWidthAttr <= 8) {
      scalingFactor = 110;
    } else if (textWidthAttr <= 10) {
      scalingFactor = 90;
    } else {
      scalingFactor = 80;
    }

    const scaleX = (Math.abs(meshWidth) / scalingFactor) + 0.2;
    const scaleY = (Math.abs(meshHeight) / scalingFactor) + 0.2;

    // update background element
    this.bgEl.setAttribute('rounded-rect', `width: ${scaleX}; height: ${scaleY}; radius: ${this.data.radius}; color: ${this.data.color}; opacity: ${this.data.opacity}`);

    this.meshUpdated = true;
  },
  update: function (oldData) {
    if (oldData.color !== this.data.color || oldData.radius !== this.data.radius || oldData.opacity !== this.data.opacity) {
      this.meshUpdated = false;
    }
    if (oldData.textColor !== this.data.textColor) {
      this.el.setAttribute('text', `color: ${this.data.textColor};`);
    }
  }
});